export default __webpack_public_path__ + "static/media/blend-graph-on1.69ea0e05.svg";